'use strict';

module.exports = {
    /**
     * 打开View时，触发<br />
     * 使用场景：需要在入场动画结束时做相应处理时绑定该事件。作为子view，被打开后触发。作为父view，子view关闭，展示后被触发<br />
     * 对应native接口：webview.onShow
     * @method hysdk.onShow
     * @category WebView Event
     * @example ./onShow.js[1-7]
     * @description
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | X    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X  |
     * | wechat  |   X   |
     * | ctrip   |   √   |
     *
     */
    show: {
        hy: {
            key: 'webview.onShow'
        }
    },
    /**
     * 关闭View时，触发<br />
     * 使用场景：需要在出场动画结束时做相应处理时绑定该事件。作为父view，子view打开，隐藏后被触发<br />
     * 对应native接口：webview.onHide
     * @method hysdk.onHide
     * @category WebView Event
     * @example ./onHide.js[1-7]
     * @description
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | X    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X  |
     * | wechat  |   X   |
     * | ctrip   |   X   |
     *
     */
    hide: {
        hy: {
            key: 'webview.onHide'
        }
    },
    /**
     * 子view关闭后接收数据触发<br />
     * 使用场景：需要接收子view反馈数据时绑定该事件。作为父view，子view关闭后被触发<br />
     * 对应native接口：webview.onReceiveData
     * @method hysdk.onReceiveData
     * @category WebView Event
     * @example ./onReceiveData.js[1-7]
     * @description
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | √    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X  |
     * | wechat  |   X   |
     * | ctrip   |   √   |
     *
     */
    receiveData: {
        hy: {
            key: 'webview.onReceiveData'
        }
    },
    /**
     * 子view关闭后触发<br />
     * 使用场景：需要知道子view关闭情况时绑定该事件。作为父view，子view关闭后被触发<br />
     * 对应native接口：webview.targetClosed
     * @method hysdk.onCloseWebView
     * @category WebView Event
     * @example ./onCloseWebView.js[1-7]
     * @description
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | √    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X  |
     * | wechat  |   X   |
     * | ctrip   |   X   |
     *
     */
    closeWebView: {
        hy: {
            key: 'webview.targetClosed'
        }
    },
    /**
     * 页面loading结束前触发<br />
     * 使用场景：解决双loading问题。在loading将要结束时，会触发这个消息，此时显示的还是hy的loading动画页面。前端回调 callback( {data: true} ) 则阻止隐藏当前的loading动画页面，之后可以调用 hysdk.hideLoadView( ) 来隐藏loading动画页面。前端回调callback( {data: false} )则立即隐藏loadingy动画。如果前端没有回调的话，则默认在500ms后关闭loading动画页面<br />
     * 对应native接口：loadingview.close
     * @method hysdk.onLoadingClose
     * @category WebView Event
     * @example ./onLoadingClose.js[1-10]
     * @description
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | √    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X  |
     * | wechat  |   X   |
     * | ctrip   |   X   |
     *
     */
    loadingClose: {
        hy: {
            key: 'loadingview.close'
        }
    },
    resize: {
        // TODO: 测试
        hy: {
            key: 'webview.resize'
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ../src/events/webview.js
// module id = 24
// module chunks = 0 2 4